import type { Invoice } from "src/types";

/** Display name of the doctor an invoice belongs to — desktop-app imports ("system") belong to the practice. */
export function invoiceOwnerLabel(
    invoice: Pick<Invoice, "ownerDoctorId" | "ownerDoctorName">,
    t: (key: string) => string,
): string {
    if (invoice.ownerDoctorId === "system") return t("invoices.ownerSystem");
    return invoice.ownerDoctorName || t("invoices.ownerUnknown");
}
